import { useEffect } from "react";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import { Nav } from "../components/site/Nav";
import { Hero } from "../components/site/Hero";
import { Chef } from "../components/site/Chef";
import { MenuQuoteCtas } from "../components/site/MenuQuoteCtas";
import { Occasions } from "../components/site/Occasions";
import { WeddingsTeaser } from "../components/site/WeddingsTeaser";
import { Footer } from "../components/site/Footer";
import { FloatingWhatsApp } from "../components/site/FloatingWhatsApp";

export default function Landing() {
  useEffect(() => {
    const hash = window.location.hash;
    if (hash) {
      setTimeout(() => document.querySelector(hash)?.scrollIntoView({ behavior: "smooth" }), 120);
    }
  }, []);

  return (
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="grain-overlay" />
      <Toaster theme="dark" position="bottom-right" />
      <Nav />
      <main>
        <Hero />
        <Chef />
        <MenuQuoteCtas />
        <Occasions />
        <WeddingsTeaser />
      </main>
      <Footer />
      <FloatingWhatsApp />
    </ReactLenis>
  );
}
